module.exports = __webpack_public_path__ + "static/media/rss.555f88ab.svg";